import { ClimatisationInfo } from "shared/types/climatisation";

interface CalculateBuildingClimatisationDotValuesProps {
    buildingClimatisationInfo: ClimatisationInfo;
}


export const calculateBuildingClimatisationDotValues = ({ buildingClimatisationInfo }: CalculateBuildingClimatisationDotValuesProps) => {
    let dotValues: any = {
        red: { count: 0, labels: [] },
        orange: { count: 0, labels: [] },
        green: { count: 0, labels: [] },
        transparent: { count: 0, labels: [] },
    };

    if(!buildingClimatisationInfo) {
        return dotValues;
    }   

    if (buildingClimatisationInfo.climatisationDevices && buildingClimatisationInfo.climatisationDevices.length > 0) {
        dotValues.green.count = buildingClimatisationInfo.climatisationDevices.length;
        for (let device of buildingClimatisationInfo.climatisationDevices) {
            dotValues.green.labels.push(device.deviceType + " ingevuld");
        }
    }

    if (buildingClimatisationInfo.gasMeters && buildingClimatisationInfo.gasMeters.length == 0) {
        dotValues.green.count++;
        dotValues.green.labels.push("Gasmeter ingevuld");

    }
    return dotValues;
};
